module.exports = __webpack_public_path__ + "img/new_banner_tr.e3a6511e.jpg";